import { ComponentPropsWithRef } from "react";
import AuthCode from "react-auth-code-input";

export const OtpInput = (props: ComponentPropsWithRef<typeof AuthCode>) => {
  return (
    <AuthCode
      containerClassName="flex w-full space-x-5"
      inputClassName="aspect-square min-h-0 min-w-0 max-w-[51px] flex-1 rounded border bg-[#1B1B1B] text-center font-serif text-[18px] font-medium transition-colors focus:bg-[#292929] focus:outline-none border-[#292929] focus:border-[#676767] disabled:bg-[#292929]"
      allowedCharacters="numeric"
      {...props}
    />
  );
};
